import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  ViewEncapsulation,
} from '@angular/core';

import { FaIconComponent } from '../../atoms';
import { faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { TranslatePipe } from '@ngx-translate/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { SizeProp } from '@fortawesome/angular-fontawesome';

export interface ContextMenuItem {
  label?: string;
  icon?: IconProp;
  clickValue?: unknown;
  divider?: boolean;
  iconClass?: string;
  iconSize?: SizeProp;
}

@Component({
  selector: 'orbit-context-menu',
  standalone: true,
  imports: [FaIconComponent, TranslatePipe],
  templateUrl: './context-menu.component.html',
  styleUrl: './context-menu.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenuComponent {
  menuClick = output<string>();
  itemClicked = output<unknown>();
  items = input<ContextMenuItem[]>();
  readonly bubbleArrow = faCaretUp;

  onItemKeyDown(event: KeyboardEvent, clickValue: unknown): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.itemClicked.emit(clickValue);
    }
  }
}
